import React from "react";
import {Link} from "react-router-dom";

import {ILicenses} from "@/services/models";
import T from "@translate/T";

export function renderSopModalMenu(project: number, licenses: ILicenses) {
    const {frac, fuge, reader, sizer, spoc, xray} = licenses;
    const stepLicense = fuge || reader || sizer || xray;

    return (
        <React.Fragment>
            {frac && (
                <div key="cat-technology" className={"mb-2"}>
                    <h5 className="header border-bottom">
                        <T>CAT-Technology</T>
                    </h5>
                    <ul className="list-unstyled" style={{columns: 4}}>
                        <li className="mb-1">
                            <Link
                                id="new-frac-sop"
                                to={`/project/${project}/fracture/wizard`}
                            >
                                <T>New LUMiFrac SOP</T>
                            </Link>
                        </li>
                    </ul>
                </div>
            )}
            {stepLicense && renderStepSops(project, licenses)}
            {spoc && (
                <div key="spoc-technology" className={"mb-2"}>
                    <h5 className="header border-bottom">
                        <T>SPLS-Technology</T>
                    </h5>
                    <ul className="list-unstyled">
                        <li className="mb-1">
                            <Link
                                id="new-spoc-sop"
                                to={`/project/${project}/spoc/wizard`}
                            >
                                <T>New LUMiSpoc SOP</T>
                            </Link>
                        </li>
                    </ul>
                </div>
            )}
        </React.Fragment>
    );
}

export function renderSopDropdownMenu(project: number, licenses: ILicenses) {
    const {frac, fuge, reader, sizer, spoc, xray} = licenses;

    return (
        <React.Fragment>
            {frac && (
                <Link
                    id="new-frac-sop"
                    to={`/project/${project}/fracture/wizard`}
                >
                    <button type="button" className="dropdown-item">
                        <T>New LUMiFrac SOP</T>
                    </button>
                </Link>
            )}
            {fuge && (
                <Link
                    id="new-fuge-sop"
                    to={`/project/${project}/centrifuge/wizard/fuge`}
                >
                    <button type="button" className="dropdown-item">
                        <T>New LUMiFuge SOP</T>
                    </button>
                </Link>
            )}
            {reader && (
                <Link
                    id="new-reader-sop"
                    to={`/project/${project}/centrifuge/wizard/reader`}
                >
                    <button type="button" className="dropdown-item">
                        <T>New LUMiReader SOP</T>
                    </button>
                </Link>
            )}
            {xray && (
                <Link
                    id="new-xr-sop"
                    to={`/project/${project}/centrifuge/wizard/xray`}
                >
                    <button type="button" className="dropdown-item">
                        <T>New LUMiReader X-Ray SOP</T>
                    </button>
                </Link>
            )}
            {sizer && (
                <Link
                    id="new-sizer-sop"
                    to={`/project/${project}/centrifuge/wizard/sizer`}
                >
                    <T>New LUMiSizer SOP</T>
                </Link>
            )}
            {spoc && (
                <Link id="new-spoc-sop" to={`/project/${project}/spoc/wizard`}>
                    <button type="button" className="dropdown-item">
                        <T>New LUMiSpoc SOP</T>
                    </button>
                </Link>
            )}
        </React.Fragment>
    );
}

function renderStepSops(project: number, licenses: ILicenses) {
    const {fuge, reader, sizer, xray} = licenses;

    return (
        <div key="step-technology" className={"mb-2"}>
            <h5 className="header border-bottom">
                <T>STEP-Technology</T>
            </h5>
            <ul className="list-unstyled" style={{columns: 4}}>
                {fuge && (
                    <li className="mb-1">
                        <Link
                            id="new-fuge-sop"
                            to={`/project/${project}/centrifuge/wizard/fuge`}
                        >
                            <T>New LUMiFuge SOP</T>
                        </Link>
                    </li>
                )}
                {reader && (
                    <li className="mb-1">
                        <Link
                            id="new-reader-sop"
                            to={`/project/${project}/centrifuge/wizard/reader`}
                        >
                            <T>New LUMiReader SOP</T>
                        </Link>
                    </li>
                )}
                {xray && (
                    <li className="mb-1">
                        <Link
                            id="new-xr-sop"
                            to={`/project/${project}/centrifuge/wizard/xray`}
                        >
                            <T>New LUMiReader X-Ray SOP</T>
                        </Link>
                    </li>
                )}
                {sizer && (
                    <li className="mb-1">
                        <Link
                            id="new-sizer-sop"
                            to={`/project/${project}/centrifuge/wizard/sizer`}
                        >
                            <T>New LUMiSizer SOP</T>
                        </Link>
                    </li>
                )}
            </ul>
        </div>
    );
}
